import { API_BASE } from '../../../api';

export const ENDPOINTS = {
    aprobadores: `${API_BASE}/Aprobadores`,
    aprobadoresById: (id) => `${API_BASE}/Aprobadores/${id}`,
    aprobadoresByUsuario: (idUsuario) => `${API_BASE}/Aprobadores/Usuario/${idUsuario}`,

    catEstadoReserva: `${API_BASE}/CatEstadoReserva`,
    catEstadoReservaById: (id) => `${API_BASE}/CatEstadoReserva/${id}`,

    catTipoVehiculo: `${API_BASE}/CatTipoVehiculo`,
    catTipoVehiculoById: (id) => `${API_BASE}/CatTipoVehiculo/${id}`,

    checklistViaje: `${API_BASE}/ChecklistViaje`,
    checklistViajeById: (id) => `${API_BASE}/ChecklistViaje/${id}`,

    aprobacionesReservas: `${API_BASE}/AprobacionesReservas`,
    aprobacionesReservasById: (id) => `${API_BASE}/AprobacionesReservas/${id}`,

    chofer: `${API_BASE}/Chofer`,
    choferDetalle: `${API_BASE}/Chofer/Detalles`,
    choferDisponibilidad: (id) => `${API_BASE}/Chofer/${id}/Disponibilidad`,
    choferById: (id) => `${API_BASE}/Chofer/${id}`,
    choferByEmpleado: (idEmpleado) => `${API_BASE}/Chofer/Empleado/${idEmpleado}`,

    choferVehiculoAsignacion: `${API_BASE}/ChoferVehiculoAsignacion`,
    choferVehiculoAsignacionById: (id) => `${API_BASE}/ChoferVehiculoAsignacion/${id}`,

    diasFestivosInhabiles: `${API_BASE}/DiasFestivosInhabiles`,
    diasFestivosInhabilesSecurity: (tipo) => `${API_BASE}/DiasFestivosInhabiles/security?tipo=${tipo}`,
    diasFestivosInhabilesById: (id) => `${API_BASE}/DiasFestivosInhabiles/${id}`,

    excepcionTurno: `${API_BASE}/ExcepcionTurno`,
    excepcionTurnoById: (id) => `${API_BASE}/ExcepcionTurno/${id}`,

    extrasAcumuladoMes: `${API_BASE}/ExtrasAcumuladoMes`,
    extrasAcumuladoMesById: (id) => `${API_BASE}/ExtrasAcumuladoMes/${id}`,

    extrasAcumuladoSemana: `${API_BASE}/ExtrasAcumuladoSemana`,
    extrasAcumuladoSemanaById: (id) => `${API_BASE}/ExtrasAcumuladoSemana/${id}`,

    parametrosLaborales: `${API_BASE}/ParametrosLaborales`,
    parametrosLaboralesSecurity: (tipo) => `${API_BASE}/ParametrosLaborales/security?tipo=${tipo}`,
    parametrosLaboralesById: (id) => `${API_BASE}/ParametrosLaborales/${id}`,

    reserva: `${API_BASE}/Reserva`,
    reservasInboxRH: `${API_BASE}/Reserva/InboxRH`,
    reservaRange: (start, end) => `${API_BASE}/Reserva/Range?start=${start}&end=${end}`,
    reservaById: (id) => `${API_BASE}/Reserva/${id}`,

    reservaNotificacion: `${API_BASE}/ReservaNotificacion`,
    reservaNotificacionById: (id) => `${API_BASE}/ReservaNotificacion/${id}`,

    siniestro: `${API_BASE}/Siniestro`,
    siniestroById: (id) => `${API_BASE}/Siniestro/${id}`,

    solicitantes: `${API_BASE}/Solicitantes`,
    solicitantesCatalogo: `${API_BASE}/Solicitantes/Catalogo`,
    solicitantesById: (id) => `${API_BASE}/Solicitantes/${id}`,
    solicitantesByEmpleado: (idEmpleado) => `${API_BASE}/Solicitantes/Empleado/${idEmpleado}`,

    solicitanteUnidadesOrganizacionales: `${API_BASE}/SolicitanteUnidadesOrganizacionales`,
    solicitanteUnidadesOrganizacionalesById: (id) => `${API_BASE}/SolicitanteUnidadesOrganizacionales/${id}`,

    tipoAprobacion: `${API_BASE}/TipoAprobacion`,
    tipoAprobacionById: (id) => `${API_BASE}/TipoAprobacion/${id}`,

    vehiculoCombustible: `${API_BASE}/VehiculoCombustible`,
    vehiculoCombustibleById: (id) => `${API_BASE}/VehiculoCombustible/${id}`,

    vehiculo: `${API_BASE}/Vehiculo`,
    vehiculoById: (id) => `${API_BASE}/Vehiculo/${id}`,

    vehiculoMantenimiento: `${API_BASE}/VehiculoMantenimiento`,
    vehiculoMantenimientoById: (id) => `${API_BASE}/VehiculoMantenimiento/${id}`,

    vehiculoOdometro: `${API_BASE}/VehiculoOdometro`,
    vehiculoOdometroById: (id) => `${API_BASE}/VehiculoOdometro/${id}`,

    //General
    empleados: `${API_BASE}/Empleados`,
    personas: `${API_BASE}/Personas`,
    personasById: (id) => `${API_BASE}/Personas/${id}`,
    correos: `${API_BASE}/Emails`,
    emailsByPersona: (idPersona) => `${API_BASE}/Emails/persona/${idPersona}`,
    usuarios: `${API_BASE}/Usuarios`,
    usuariosById: (id) => `${API_BASE}/Usuarios/${id}`,
    unidadesOrg: `${API_BASE}/UnidadesOrganizacionales`,
    unidadesOrgSecurity: (tipo) => `${API_BASE}/UnidadesOrganizacionales/security?tipo=${tipo}`,
    empresasUnidadesOrg: `${API_BASE}/EmpresasUnidadesOrg`,
    empresas: `${API_BASE}/Empresas`,
    unidadesOrgEmpleado: `${API_BASE}/UnidadesOrgEmpleado`,
    unidadesOrgEmpleadoById: (id) => `${API_BASE}/UnidadesOrgEmpleado/${id}`,

    //RelojChecador    
    turnos: `${API_BASE}/Turnos`,

    //Seguridad
    empleadosTurnos: `${API_BASE}/EmpleadosTurnos`,
}
